import CountUp from "react-countup";

const RetornoVisitantes = ({ percentual }) => {
  return (
    <div className="bg-white rounded-2xl shadow p-4 text-center">
      <p className="text-sm text-gray-500">Visitantes que retornaram</p>
      <p className="text-2xl font-bold text-yellow-600">
        <CountUp end={percentual} duration={1.5} decimals={1} suffix="%" />
      </p>
      <p className="text-xs text-gray-400 mt-1">
        Visitaram mais de uma vez
      </p>
    </div>
  );
};

export default RetornoVisitantes;
